import ApiService from "./api.service";

const StaffService = {
  async staffSearch(query, page = 0, year) {
    try {
      const search = query ? encodeURIComponent(query) : "no-query";
      const params = new URLSearchParams({ page: String(page) });

      if (year) {
        params.set("year", String(year));
      }

      const response = await ApiService.get(
        `staff/users/search/${search}?${params.toString()}`,
      );
      if (response.status == 200) {
        return response.data;
      }
    } catch (e) {
      return e.response;
    }
  },

  async staffSearchAll(query, year) {
    try {
      const search = query ? encodeURIComponent(query) : "no-query";
      const params = new URLSearchParams();

      if (year) {
        params.set("year", String(year));
      }

      const queryString = params.toString();
      const response = await ApiService.get(
        `staff/users/search/${search}/export${queryString ? `?${queryString}` : ""}`,
      );

      if (response.status == 200) {
        return response.data;
      }
    } catch (e) {
      return e.response;
    }
  },

  async vouchers() {
    try {
      let response = await ApiService.get(`staff/vouchers`);
      if (response.status == 200) {
        return response.data;
      }
    } catch (e) {
      return e.response;
    }
  },

  async voucherInfo(code) {
    try {
      let response = await ApiService.get(`voucher-info?code=${code}`);
      if (response.status == 200) {
        return response.data;
      }
    } catch (e) {
      return e.response;
    }
  },

  async staffStats(id) {
    try {
      let response = await ApiService.get(`staff/users/${id}/stats`);
      if (response.status == 200) {
        return response.data;
      }
    } catch (e) {
      return e.response;
    }
  },
};

export { StaffService };
